import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';


@Injectable({
  providedIn: 'root'
})
export class TrainingPlanCourseThemeApiService extends ApiService {
  readonly resourcePath = 'training_plan_course_themes';

  list(id:string): Observable<HydraCollection<any>> {
    return this.restList({'organisationProfile': '/organisation_profiles/'+id});
  }

  get(id:string): Observable<any>{
    return this.restRead(id);
  }

  create(data: object): Observable<any> {
    return this.restCreate<any>(data);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }
  delete(id:string){
    return this.restDelete(id);
  }
}
